import React from "react";
import routerProvider from "@pankod/refine-react-router-v6";
import { TitleProps } from "@pankod/refine-core";

const { Link } = routerProvider;

export const Title: React.FC<TitleProps> = ({ collapsed }) => (
  <Link to="/" className="ams-brand-link">
    {collapsed ? (
      <img
        src={"/images/icon.png"}
        alt="Centa"
        className="ams-brand-icon"
      />
    ) : (
      <img
        src={"/images/logo-light.png"}
        alt="Centa"
        className="ams-brand-logo"
      />
    )}
  </Link>
);
